import { Component } from '@angular/core';

@Component({
  selector: 'in2-bottom-spacer',
  template: '<div class="bottom-spacer"></div>',
  styles: [
    `
      .bottom-spacer {
        height: 70px;
      }
    `,
  ],
  standalone: false,
})
export class BottomSpacerComponent {
  /**
   * Composant utilisé pour ajouter de la marge en bas des pages et
   * ainsi empêcher le contenu de s'afficher en dessous de la barre de navigation
   * android.
   *
   * Le bug de superposition est causé par l'option resizeOnFullScreen du clavier.
   */
  constructor() {}
}
